import { cx } from "./cx";

/**
 * Prominent product/supplier code badge (iQ codes, manufacturer part numbers,
 * supplier SKUs). `dim` renders the secondary-code variant.
 */
export function CodeChip({
  code,
  dim,
  title,
}: {
  code: string | null | undefined;
  dim?: boolean;
  title?: string;
}) {
  if (!code) return <span className="mono">—</span>;
  return (
    <span className={cx("code-chip", dim && "dim")} title={title}>
      {code}
    </span>
  );
}
